import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { DateRangeInput } from "ui";

import { FilterFormValues } from "../TransactionsFilterForm.types";

import styles from "../TransactionsFilterForm.module.scss";

export const DateRangeBlock = () => {
  const { t } = useTranslation();

  const { control } = useFormContext<FilterFormValues>();

  return (
    <div className={styles["filter-form__date"]}>
      <h4 className={styles["filter-form__date--title"]}>
        {t("Date (from/to)")}
      </h4>

      <div className={styles["filter-form__date--range"]}>
        <Controller
          control={control}
          name="dateRange"
          render={({ field: { value, onChange } }) => (
            <DateRangeInput value={value} onChange={onChange} />
          )}
        />
      </div>
    </div>
  );
};
